import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Navbar.tsx");
